import { StackGrid } from "@data-display/layout/StackGrid";
import { Button } from "@mui/material";
import clsx from "clsx";
import { type ReactNode, useMemo } from "react";
import { useDRPContext } from "../../context";
import { useDRYPContext } from "./context";
import { yearList } from "./logics";
import { DRYPYearItemContainer, yearItemClasses } from "./styles";

const DRYPYearItem = ({ year }: { year: number }) => {
  const { minDate, maxDate, endDateDisabled } = useDRPContext();
  const { handleMouseEnter, handleMouseLeave, handleSelect, isSelected, isBetween, selectRange } = useDRYPContext();

  const selected = isSelected(year);
  const between = selected === "false" && isBetween(year);
  const disabled = (minDate && year < minDate.getFullYear()) || (maxDate && year > maxDate.getFullYear());

  return (
    <DRYPYearItemContainer
      className={clsx(yearItemClasses.root, {
        [yearItemClasses.divStartSelected]: selected === "start" && selectRange.endDate,
        [yearItemClasses.divEndSelected]: selected === "end" && selectRange.startDate,
        [yearItemClasses.between]: between && selected === "false",
      })}
    >
      <Button
        className={clsx(yearItemClasses.button, {
          [yearItemClasses.selected]: selected !== "false",
        })}
        onMouseEnter={() => handleMouseEnter(year)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleSelect(year, endDateDisabled)}
        disabled={disabled}
      >
        {year}
      </Button>
    </DRYPYearItemContainer>
  );
};

const PER_LINE = 8;

export const DRYPYear = () => {
  useDRYPContext();

  const items = useMemo(() => {
    const items: ReactNode[] = [];
    for (const year of yearList) {
      items.push(<DRYPYearItem key={year} year={year} />);
    }
    return items;
  }, []);

  return (
    <StackGrid perLine={PER_LINE} width={PER_LINE * 64} rowGap={0.5} boxSizing="border-box">
      {items}
    </StackGrid>
  );
};
